import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface UpdatePlanPayload {
  description: string;
  batch_enabled: boolean;
  realtime_enabled: boolean;
  realtime_max_concurrent_streams?: number | null;
  realtime_languages?: string[] | null;
  alignment_enabled: boolean;
  translation_enabled: boolean;
  stt_limit: number;
  media_unit_size: number;
  stt_pricing_plan: number;
  alignment_pricing_plan: number;
  translation_pricing_plan?: number | null;
  translation_cost: number;
  translation_characters: number;
  translation_character_limit?: number | null;
  monthly_cost: number;
  cost: number;
  minimal_invoice: number;
  automatic_training_enabled: boolean;
  automatic_training_unit_cost: number;
  automatic_training_monthly_cost: number;
  processing_type: string;
  // Fair use fields
  is_fair_use?: boolean;
  fair_use_rate_limit?: number | null;
  automatic_training_unit_limit?: number | null;
  automatic_training_hosting_limit?: number | null;
  custom_model_yearly_limit?: number | null;
  // Exceedance email alerts
  send_exceedance_email?: boolean;
  exceedance_email_recipients?: string | null;
  // AI Summaries
  ai_summaries_enabled?: boolean;
  ai_summaries_monthly_limit?: number | null;
}

export const useUpdatePlan = () => {
  const queryClient = useQueryClient();

  const updatePlan = async (plan_id: string, data: UpdatePlanPayload) => {
    const response = await Axios.patch(
      `${POST_URL(plan_id.toString()).updatePlan}`,
      data
    );
    return response.data;
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    { plan_id: string; data: UpdatePlanPayload }
  >(({ plan_id, data }) => updatePlan(plan_id, data), {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries('plans');
      queryClient.invalidateQueries(['planBoDetailed', variables.plan_id]);
    },
    useErrorBoundary: false
  });
};
